<template>
  <div class="header__order">
    <FluidContainer>
      <div class="header__order--wrapper">
        <div @click="goBack" class="header__order-back"><Icon icon="tick" /></div>
        <div class="header__order-logo">
          <a href="/"><img :src="data.logo.src" :alt="data.logo.alt"></a>
        </div>
        <div class="header__order-description">
          <h1>{{ data.headline }}</h1>
          <i>{{ data.subHeadline }}</i>
        </div>
        <div class="header__order-secured">
          <!-- <Icon icon="mobile" /> -->
          <img src="assets/images/padlock.png">
          <p v-html="data.securityText" />
        </div>
      </div>
    </FluidContainer>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import FluidContainer from '@/components/FluidContainer'
import Icon from '@/components/Icon'

@Component({
  components: {
    FluidContainer,
    Icon,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
    backOfferForm: {
      type: HTMLFormElement,
      required: false,
    },
  },
})
export default class BookingHeader extends Vue {
  logoSrc = 'assets/images/logo.png'
  logoAlt = 'logo'
  securityText = 'Chronimy Twoje dane<br>certyfikatem bezpieczeństwa SSL'
  headline = 'Witamy w procesie rezerwacji'
  subheadline = 'To łatwe, kupisz wycieczkę tylko w 1 kroku'

  goBack () {
    if (this.backOfferForm) this.backOfferForm.submit()
  }
}
</script>

<style lang="scss" scoped>
.header__order {
  padding: 5px 0;
  box-shadow: 0 3px 8px -7px #000000;
  z-index: 2;
  position: relative;

  &--wrapper {
    padding: 0 20px;
    display: flex;
    width: 100%;
    align-items: center;

    @include mediaFluid(tablet) {
      padding: 0;
    }
  }

  @include mediaFluid(desktop) {
    padding: 9px 0 8px;
  }

  &-back {
    font-size: 12px;
    margin-right: 3px;
    margin-left: -4px;
    transform: rotate(90deg);
    color: #005CA9;

    @include mediaFluid(tablet) {
      display: none;
    }
  }

  &-logo {
    flex: 1 0 auto;

    @include mediaFluid(tablet) {
      flex: 0;
    }

    img {
      width: 43px;
      height: 100%;

      @include mediaFluid(tablet) {
        width: 50px;
      }

      @include mediaFluid(desktop) {
        width: 58px;
      }
    }
  }

  &-description {
    display: none;
    font-family: 'Gotham';
    color: #005ca9;

    @include mediaFluid(tablet) {
      display: flex;
      flex: 1 0 auto;
      flex-direction: column;
      margin-left: 25px;
      line-height: normal;
    }

    h1 {
      font-weight: bold;
      font-size: 1.25em;
      text-transform: uppercase;
      margin: 0;

      @include mediaFluid(desktop) {
        font-size: 1.7em;
      }
    }

    i {
      font-family: 'Georgia';
      font-weight: 400;
      font-size: .85em;
      padding-left: 38px;
      position: relative;

      @include mediaFluid(desktop) {
        padding-left: 55px;
        font-size: 1.15em;
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 5px;
        width: 28px;
        height: 4px;
        background-color: #005ca9;

        @include mediaFluid(desktop) {
          width: 40px;
          height: 6px;
          top: 8px;
        }
      }
    }
  }

  &-secured {
    display: flex;
    align-items: center;
    color: #E71F6C;
    margin-left: 20px;
    width: 190px;

    @include mediaFluid(tablet) {
      margin-left: 80px;
      margin-right: 10px;
    }

    @include mediaFluid(desktop) {
      width: 400px;
    }

    p {
      margin: 0;
      font-family: 'Gotham';
      font-weight: normal;
      text-align: left;
      font-size: .7em;
      line-height: normal;

      @include mediaFluid(tablet) {
        font-size: .85em;
        font-weight: bold;
      }

      @include mediaFluid(desktop) {
        font-size: 1em;
      }
    }

    img {
      margin-right: 5px;
      margin-bottom: 2px;
      width: 18px;

      @include mediaFluid(tablet) {
        margin-right: 7px;
        margin-bottom: 0;
        width: 21px;
      }

      @include mediaFluid(desktop) {
        margin-right: 9px;
        width: 25px;
      }
    }

    span {
      font-size: 25px;
      margin-right: 5px;

      @include mediaFluid(desktop) {
        font-size: 32px;
      }
    }
  }

  > div {
    display: flex;
    align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BookingHeader.vue